import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { MarkerPhotos } from "./models/MarkerPhotos";
import { MarkerDetails } from "./models/MarkerDetails";
import Point from 'ol/geom/Point';

export class MapMovement{
    constructor( public readonly coords: string, public readonly center: boolean = false, public readonly fromMap: boolean = false){}
}

export class MapPrint{
    constructor( public readonly canRenderMap: boolean, public readonly canPrintMap: boolean = false){}
}

export default class GeoTaggingVuexModule extends AbacoVuexModule {
    @State() businessId!: any;
    @State() markerId!: string;
    @State() addingMarker!: boolean;
    @State() showMDetails!: boolean;
    @State() mapPrint!: MapPrint | null;
    @State() photoCounter!: number;
    @State() coordsSelected!: MapMovement | null;
    @State() photoId!: number;
    @State() mapPhotosPath!: string[];
    @State() markerPhotos!: MarkerPhotos[] | null; //list of marker photos
    @State() markerDetails!: MarkerDetails | null; //marker details
    @State() userPointLocation!: Point;
    @State({ default: false }) isStandalone!: boolean;
    @State() assignedUserViewAuthorization!: boolean;
    @State() editAuthorization!: boolean;
    @State() viewAuthorization!: boolean;
    @State({ default: false }) dataLoaded!: boolean;
}
